import _isEmpty from 'underscore/cjs/isEmpty.js'

import {
  contentfulFetch,
  generateArticlesObjectFromContentful,
  generateNewsObjectFromContentful,
  isValidUrl
} from '~/services/contentful/helpers/functions'

export const useGuidesStore = defineStore('guides', {
  state: () => {
    return {
      authorPosts: {
        items: []
      }
    }
  },

  actions: {
    getArticle ({ vertical, slug, preview = false } = {}) {
      return useFetch('/api/contentful/guides/get-article', {
        method: 'post',
        body: {
          vertical,
          slug,
          preview
        }
      }).then(response => {
        if (!_isEmpty(response?.error?.value?.data)) {
          throw(response?.error?.value?.data)
        }

        return response?.data.value || null
      })
    },

    async getAuthorPosts ({
      author,
      authorUrl,
      preview = false,
      offset = 0,
      limit = 5,
      slug,
      slugNot,
      tags = []
    } = {}) {
      const data = await contentfulFetch('/api/contentful/guides/get-author-posts', {
        method: 'POST',
        body: {
          ...removeFalseyObj({
            author,
            authorUrl: authorUrl ? `/${authorUrl}` : null,
            slug,
            slugNot,
            tags
          }),
          preview,
          offset,
          limit
        }
      })

      const items = data?.items

      this.authorPosts.total = data?.total

      if (!offset) {
        this.authorPosts.items = items
        return data
      }

      if (isObject(items)) {
        this.authorPosts.items.push(items)
      } else {
        this.authorPosts.items.push(...items)
      }

      return data
    },

    fetchArticlesByVertical: async (vertical = [], limit = 12, skip = 0, preview = false) => {
      try {
        const articles = await contentfulFetch('/api/contentful/guides/get-articles-by-vertical', {
          method: 'POST',
          body: {
            vertical,
            limit,
            skip,
            preview
          }
        })

        if (!articles) {
          return null
        }

        const items = articles.items.map(generateArticlesObjectFromContentful)

        return {
          ...articles,
          items
        }
      } catch {
        return null
      }
    },

    fetchRelatedArticles: async (vertical = '', slug = '', preview = false, limit = 4) => {
      try {
        const articles = await contentfulFetch('/api/contentful/guides/get-related-articles', {
          method: 'POST',
          body: {
            vertical,
            slug,
            limit,
            preview
          }
        })

        if (!articles) {
          return null
        }

        const items = articles.items.map(item => {
          const newObject = {
            title: item.title,
            slug: item.slug,
            mainContent: item.mainContent,
            featureImage: item.featureImage,
            author: {},
            vertical: ''
          }

          if (item.featureImage?.url && !isValidUrl(item.featureImage?.url)) {
            newObject.featureImage = {
              ...newObject.featureImage,
              url: `https:${item.featureImage.url}`
            }
          }

          return generateNewsObjectFromContentful(
            newObject,
            {
              layout: 'vertical'
            },
            true
          )
        })

        return {
          ...articles,
          items
        }
      } catch {
        return null
      }
    },

    fetchFeaturedArticlesByVertical: async (vertical = [], limit = 12, skip = 0, preview = false) => {
      try {
        const articles = await contentfulFetch('/api/contentful/guides/get-featured-articles-by-vertical', {
          method: 'POST',
          body: {
            vertical,
            limit,
            skip,
            preview
          }
        })

        if (!articles) {
          return null
        }

        const items = articles.items.map(item => ({
          ...generateArticlesObjectFromContentful(item),
          isOvhc: !!item.isOvhc
        }))

        return {
          ...articles,
          items
        }
      } catch {
        return null
      }
    }
  }
})
